import * as events from '@/events'
import { API } from '@/modules/api'
import QueryString from '@/utils/QueryString'

let offercode = new QueryString().get('offercode')

export default {
  methods: {
    watchForOfferChange () {
      events.formsListUpdated.subscribe(() => {
        const newOfferCode = new QueryString().get('offercode')

        if (offercode != newOfferCode) {
          this.setNewOfferCode(newOfferCode)
          this.fetchWeatherData()
        }
      })
    },

    setNewOfferCode (code) {
      offercode = code
    },

    async fetchWeatherData () {
      const config = { offercode, configurationId: this.data.configurationId }
      return await new API().getWeatherWidgetData(config)
        .then(data => {
          this.$set(this.weatherData, 'DailyData', data.DailyData)
          this.$set(this.weatherData, 'YearlyData', data.YearlyData)
        })
    },

    isOfferPage () {
      return new QueryString().exists('offercode')
    },
  },
}


// WEBPACK FOOTER //
// ./src/components/WeatherWidgetMixin.js